const BASE_GATEWAY = process.env.REACT_APP_PINATA_GATEWAY_BASE || 'mypinata.cloud';

export const ROOT_DOMAIN = '.'+BASE_GATEWAY;
